import '@ionq/ui/globals.css';
// The kit's dark variables remapped onto the shell's ladder (see the file).
import '@ionq/legacy-ui/styles/ionq-ui-dark.css';
import { createRoot } from 'react-dom/client';
import App from './App';
import { installAppUpdateHandling } from './lib/appUpdate';

// NOTHING COMPONENT-SHAPED MAY LIVE IN THIS FILE (no `const X = create…()`
// bindings rendered as JSX): plugin-react would add a Fast Refresh footer
// whose self-import diverges from the MF plugin's unstamped entry proxy after
// any HMR touch, evaluating this module twice — two createRoot() calls
// fighting over #root ("Failed to execute 'removeChild'"). Same trap as the
// remote's entry — see ionq-cloud-ui #1540.

// Before render: dynamic-import rejections land in microtasks, which can't
// run before the entry module graph finishes evaluating, so the chunk-error
// listener is in place for the earliest possible failure.
installAppUpdateHandling();

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);

root.render(<App />);
